import {
  BaseModel,
  BaseModelPagedArray,
  BaseModelPagedRequest
} from '../base/base-model';

export interface User extends BaseModel {
  id: number;
  email: string;
  realname: string;
  logins: number;
  failed_attempts: number;
  last_login: Date;
  last_attempt: Date;
  created: Date;
  updated: Date;
  role: string;
  language: string;
  active?: boolean;
  contacts: any[];
  gravatar: string;
  two_factor_enabled?: number | boolean;
  two_factor_secret?: string;
  form_grants?: import('../auth/form-grants').FormGrant[];
  /** Global+legacy permission names for the user's role (from /users/me). */
  permissions?: string[];
  /**
   * True when the user authored at least one report (posts.user_id).
   * When true, hard-delete is blocked; use deactivate instead.
   */
  has_posts?: boolean;
}

export interface ForgotPasswordResponse {
  status: boolean;
  message?: string;
}

export interface UserRegistration {
  email: string;
  realname: string;
  password: string;
  role: string;
}

export interface Permission {
  id: number,
  name: string,
  description: string
}

export enum ContactType {
  Phone = 'phone',
  Email = 'email',
  Twitter = 'twitter'
}

export interface Contacts {
  id: number;
  user_id: number;
  data_source: string,
  type: string;
  contact: string;
}

export interface Users extends BaseModelPagedArray<User> {
  id?: number;
}

export interface ListUserOptions extends BaseModelPagedRequest {
  role?: string;
  q?: string;
  active?: number;
  /** 0 = skip contacts in list responses (faster). Default handled by API. */
  include_contacts?: 0 | 1;
}

export enum Roles {
  SUPER_ROLE = 'super',
  ADMIN_ROLE = 'admin',
  MGMT_ROLE = 'Management User',
  OPERATOR_ROLE = 'operatoruser'
}
